import { render, staticRenderFns } from "./LeadsByInmo.vue?vue&type=template&id=214e8540"
import script from "./LeadsByInmo.vue?vue&type=script&lang=js"
export * from "./LeadsByInmo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports